/* Announcement bar: rotates the announcements with Splide when there is more
   than one, and follows block selection in the theme editor. */

if (!customElements.get('nm-announcement-bar')) {
  customElements.define(
    'nm-announcement-bar',
    class NmAnnouncementBar extends HTMLElement {
      connectedCallback() {
        if (typeof Splide === 'undefined') return;
        if (this.querySelectorAll('.splide__slide').length < 2) return;

        const i18n = {};
        if (this.dataset.prevLabel) i18n.prev = this.dataset.prevLabel;
        if (this.dataset.nextLabel) i18n.next = this.dataset.nextLabel;
        if (this.dataset.carouselLabel) i18n.carousel = this.dataset.carouselLabel;

        this.splide = new Splide(this, {
          type: 'loop',
          perPage: 1,
          arrows: true,
          pagination: false,
          autoplay: this.dataset.autoplay === 'true',
          interval: (parseInt(this.dataset.interval, 10) || 5) * 1000,
          i18n,
        });
        this.splide.mount();

        if (window.Shopify && Shopify.designMode) {
          this.onBlockSelect = (event) => {
            if (!this.contains(event.target)) return;
            const slides = Array.from(this.querySelectorAll('.splide__slide:not(.splide__slide--clone)'));
            const index = slides.indexOf(event.target);
            if (index < 0) return;
            this.splide.Components.Autoplay.pause();
            this.splide.go(index);
          };
          this.onBlockDeselect = (event) => {
            if (!this.contains(event.target)) return;
            if (this.dataset.autoplay === 'true') this.splide.Components.Autoplay.play();
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        }
      }

      disconnectedCallback() {
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.splide?.destroy(true);
        this.splide = null;
      }
    }
  );
}
